// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"744c0c79","268":"f590b59f","312":"7badc3b0","551":"e5dbc473","627":"ddfeb060","653":"db6a2d2e","738":"f74cded7","842":"0e662b50","879":"c627684d","923":"3fb9c3b9"}[chunkId] + ".chunk.js";
};